module.exports = __webpack_public_path__ + "img/Junker.5209ded0.jpg";